import { render, staticRenderFns } from "./phoneCodeLogin.vue?vue&type=template&id=1af28ade&scoped=true"
import script from "./phoneCodeLogin.vue?vue&type=script&lang=js"
export * from "./phoneCodeLogin.vue?vue&type=script&lang=js"
import style0 from "./phoneCodeLogin.vue?vue&type=style&index=0&id=1af28ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af28ade",
  null
  
)

export default component.exports